export default "__VITE_ASSET__417cb007__"